import { useContext } from 'react';
import { ServicesContext } from '@packages/shared/core/common/context';

export function useServices() {
  return useContext(ServicesContext);
}
